export const DRAFT = 'draft';
export const PENDING_QUOTATION = 'pending_quotation';
export const TERMINATED = 'terminated';
export const OPEN = 'open';
export const CANCELLED = 'cancelled';

const names = {
    [DRAFT]: 'booking.status_quotation_draft',
    [PENDING_QUOTATION]: 'booking.status_pending_quotation',
    [TERMINATED]: 'booking.status_terminated',
    [OPEN]: 'booking.status_open',
    [CANCELLED]: 'booking.status_cancelled',
};

export const bookingStatus = [
    {
        value: TERMINATED,
        label: serviceName(TERMINATED)
    },
    {
        value: OPEN,
        label: serviceName(OPEN)
    },
    {
        value: CANCELLED,
        label: serviceName(CANCELLED)
    }
];

export const quotationStatus = [
    {
        value: DRAFT,
        label: serviceName(DRAFT)
    },
    {
        value: PENDING_QUOTATION,
        label: serviceName(PENDING_QUOTATION)
    }
];


export function serviceName(type) {
    return names[type];
}
